export const SocialShares = {
  onLoad: function() {
    if ($('.social-shares').length) {
      this.onShare();
    }
  },
  onShare: function() {
    $('.open-share-window').on( 'click', function(e) {
      e.preventDefault();
      window.open($(this).attr('href'), 'share_window', 'left=20, top=20, width=500, height=500, toolbar=1, resizable=0');
      return false;
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/layouts/SocialShares.js